import { ArrowDownRight, ArrowRight, ArrowUpRight } from "lucide-react";

interface Props {
  label: string;
  value: string;
  delta?: number | null;
  unit?: string;
  deltaUnit?: string;
  deltaDigits?: number;
  status?: "data" | "stale" | "na";
  eyebrow?: string;
  help?: string;
  takeaway?: string;
}

export default function MetricCard({
  label,
  value,
  delta = null,
  unit,
  deltaUnit,
  deltaDigits = 2,
  status = "data",
  eyebrow,
  help,
  takeaway
}: Props) {
  const Icon = delta == null ? ArrowRight : delta > 0 ? ArrowUpRight : delta < 0 ? ArrowDownRight : ArrowRight;

  return (
    <article className={`metric-card metric-card--${status}`}>
      <div className="metric-card__top">
        <div>
          {eyebrow && <div className="metric-card__eyebrow">{eyebrow}</div>}
          <h3>{label}</h3>
        </div>
        <span className="metric-card__status">{status === "na" ? "N/A" : status === "stale" ? "지연" : "정상"}</span>
      </div>
      <div className="metric-card__value">{value}{unit && <span>{unit}</span>}</div>
      <div className="metric-card__delta">
        <Icon size={15} />
        {delta == null
          ? "변화 계산 불가"
          : `${delta > 0 ? "+" : ""}${delta.toFixed(deltaDigits)}${deltaUnit ? ` ${deltaUnit}` : ""} 최근 관측변화`}
      </div>
      {takeaway && <p className="metric-card__takeaway">{takeaway}</p>}
      {help && <details className="metric-card__help"><summary>지표 뜻</summary><p>{help}</p></details>}
    </article>
  );
}
